import "./CoordinatorPage.css";

import SingleCoordinatorFundraiserComponentDisplay from "../../../components/Dashboard/Coordinator/SingleCoordinatorFundraiserDisplay";
import ProfileBanner from "../../../components/Dashboard/ProfileBanner";
import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { getCurrentlyLoggedInUser } from "../../../CommonFunctions";
import { useNavigate } from "react-router-dom";
import { LoggedInAccount } from "../../../Interfaces/AccountUsers";

const CoordinatorPage = () => {
  const { linkExtension } = useParams<{ linkExtension: string }>();
  const fundraiserID = linkExtension ? parseInt(linkExtension, 10) : 0;
    const navigate = useNavigate();

  const [loggedInAccount, setLoggedInAccount] =
    useState<LoggedInAccount | null>(null);

  useEffect(() => {
    const fetchLoggedInAccount = async () => {
      try{
        const user = await getCurrentlyLoggedInUser();
        setLoggedInAccount(user);
      }
      catch (error){
        navigate("/login");
      }
    };

    fetchLoggedInAccount();
    document.title = "Fundraiser Coordinator Dashboard";
  }, []);

  return (
    <div className="coordinator-dashboard-page-layout-container">
      {loggedInAccount && (
        <>
          <div className="coordinator-dashboard-page-profile-banner">
            <ProfileBanner
              name={`${loggedInAccount.first_name} ${loggedInAccount.last_name}`}
              role="Fundraiser Coordinator"
              profile_pic={loggedInAccount.profile_pic}
            />
          </div>
          <div className="coordinator-dashboard-page-main-content">
            <div className="coordinator-dashboard-page-fundraiser-info">
              <SingleCoordinatorFundraiserComponentDisplay
                accountID={loggedInAccount.id}
                fundraiserID={fundraiserID}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default CoordinatorPage;
